"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.handleCkeditorEvents = void 0;

var _handleUploadFile = require("./handleUploadFile");

var _handleStopPropagationNnofullscreen = require("./handleStopPropagationNnofullscreen");

//ckeditor事件监听
var handleCkeditorEvents = function handleCkeditorEvents(_ref) {
  var editor = _ref.editor,
      noFile = _ref.noFile,
      initValue = _ref.initValue,
      className = _ref.className,
      handleUpload = _ref.handleUpload,
      handleNotification = _ref.handleNotification;
  //编辑器创建完毕事件
  editor.on('instanceReady', function (e) {
    //给富文本编辑器设置初始值
    e.editor.setData(initValue); //设置样式

    if (className) {
      if (/\ /.test(className)) {
        var multiClass = className.split(" ");
        multiClass.forEach(function (item) {
          document.getElementById("cke_editor").classList.add(item);
        });
      } else {
        document.getElementById("cke_editor").classList.add(className);
      }

      document.getElementsByClassName("cke_inner")[0].style.cssText = ["height:100%;", "display:flex;", "flex-direction:column;"].join("");
      document.getElementsByClassName("cke_contents")[0].style.cssText = "flex:1;"; // $("#cke_editor").addClass(className)
      // let ckeditorHeight = $("#cke_editor").height(),
      //     ckeditorToolbarHeight = $(".cke_top").outerHeight(),
      //     ckeditorBottomHeight = $(".cke_bottom").outerHeight(),
      //     ckeditorContentHeight = ckeditorHeight - ckeditorToolbarHeight - ckeditorBottomHeight;
      // $(".cke_contents").css({
      //     height:ckeditorContentHeight
      // })
    } //阻止事件并禁止视频全屏


    (0, _handleStopPropagationNnofullscreen.handleStopPropagationNnofullscreen)();
  }); //对话框事件

  CKEDITOR.on('dialogDefinition', function (e) {
    var dialogType = e.data.name,
        dialogDefinition = e.data.definition,
        onOk = dialogDefinition.onOk;

    if (dialogType == "image") {
      var bodyWidth = document.getElementsByClassName("cke_wysiwyg_frame")[0].contentWindow.document.body.offsetWidth,
          rate,
          width_ckeDomEle,
          height_ckeDomEle,
          imgWidth,
          imgHeight;

      dialogDefinition.onOk = function (e) {
        //图片等比显示
        width_ckeDomEle = this.getContentElement('info', 'txtWidth');
        height_ckeDomEle = this.getContentElement('info', 'txtHeight');
        imgWidth = width_ckeDomEle.getValue();
        imgHeight = height_ckeDomEle.getValue(); //控制显示尺寸

        if (imgWidth > bodyWidth) {
          rate = imgWidth / imgHeight;
          height_ckeDomEle.setValue("".concat(bodyWidth / rate, "px;"));
        } //阻止事件并禁止视频全屏


        (0, _handleStopPropagationNnofullscreen.handleStopPropagationNnofullscreen)();
        onOk && onOk.apply(this, e);
      };
    } else if (dialogType == "html5video") {
      dialogDefinition.onOk = function (e) {
        //插入视频默认显示控制条
        this.getContentElement("info", "controls").setValue(true); //阻止事件并禁止视频全屏

        (0, _handleStopPropagationNnofullscreen.handleStopPropagationNnofullscreen)();
        onOk && onOk.apply(this, e);
      };
    } else if (dialogType == "link") {
      dialogDefinition.onOk = function (e) {
        //插入超链接默认新窗口打开
        this.getContentElement("target", "linkTargetType").setValue("_blank");
        onOk && onOk.apply(this, e);
      };
    }
  }); //对话框显示

  editor.on('dialogShow', function (e) {
    var imgUploadBtnId = "imageUploadBtn_cke",
        videoUploadBtnId = "videoUploadBtn_cke",
        videoCoverUploadBtnId = "videoCoverUploadBtn_cke",
        imageDOMTemplate = "<div class=\"customUploadDialog_cke\">\n                                    <button id=\"".concat(imgUploadBtnId, "\" type=\"button\" class=\"uploadbtn_cke btn btn-default\">\u4E0A\u4F20</button>\n                                    <div class=\"process_cke\"></div>\n                                </div>"),
        videoDOMTemplate = "<div class=\"customUploadDialog_cke\">\n                                    <button id=\"".concat(videoUploadBtnId, "\" type=\"button\" class=\"uploadbtn_cke btn btn-default\">\u4E0A\u4F20</button>\n                                    <div class=\"process_cke\"></div>\n                                </div>"),
        videoCoverDOMTemplate = "<div class=\"customUploadDialog_cke-videoCover\" style=\"margin-top:5px;\">\n                                        <div class=\"customUploadDialog_cke--videoCover-main\" style=\"display:flex;\">\n                                            <button id=\"".concat(videoCoverUploadBtnId, "\" type=\"button\" class=\"uploadbtn_cke btn btn-default\">\u4E0A\u4F20</button>\n                                            <div style=\"line-height:27px;padding-left:5px;\">\u89C6\u9891\u5C01\u9762\u9700\u548C\u89C6\u9891\u5C3A\u5BF8\u4FDD\u6301\u4E00\u81F4\uFF0C\u5426\u5219\u4F1A\u51FA\u73B0\u53D8\u5F62\u7684\u60C5\u51B5</div>\n                                        </div>\n                                        <div class=\"process_cke\"></div>\n                                    </div>"),
        handleFakeOkBtnDOMTemplate = function handleFakeOkBtnDOMTemplate(left) {
      return "<div onclick=\"handleFakeOkBtnClick()\" id=\"fake-ok-btn\" style=\"cursor:pointer;position:absolute;top:0px;left:".concat(left, "px;width:53px;height:28px;\"></div>");
    },
        //控制台输出eventInfo, 发现data属性后有灰色的CKEDITOR.dialog
    //从而确定e.data就是CKEDITOR.dialog, 继而能通过查阅dialog文档使用CKEDITOR.dialog的相关方法和属性
    dialogObj = e.data,
        dialogType = dialogObj.getName(),
        dialogFooterBtnTr = dialogObj.getElement().findOne("table>tbody>tr>td>div>table.cke_dialog_contents>tbody>tr:nth-child(2)>td>table>tbody>tr"),
        // dialogBodyDiv = dialogObj.getElement().findOne("table>tbody>tr>td>div.cke_dialog_body"),
    eleId,
        promptMsg; //新增一个元素盖住原来的确定按钮
    //防止重复添加元素, 当count为零的时候再添加, 不能return, 不然后面的语句就会都不执行了
    //同时应该只有图片,视频,iframe,超链接对话框的时候做这个操作


    switch (dialogType) {
      case "image":
      case "html5video":
      case "link":
      case "iframe":
        if (!dialogFooterBtnTr.find("div[id='fake-ok-btn']").count()) {
          dialogFooterBtnTr.setStyle("position", "relative");

          switch (dialogFooterBtnTr.findOne("td>a").getAttribute("title")) {
            case "取消":
              dialogFooterBtnTr.appendHtml(handleFakeOkBtnDOMTemplate(58));
              break;

            case "确定":
              dialogFooterBtnTr.appendHtml(handleFakeOkBtnDOMTemplate(0));
              break;
          }
        }

        break;
    }

    if (dialogType == "image") {
      eleId = "txtUrl";
      promptMsg = "缺少图像源文件地址";
    } else if (dialogType == "html5video") {
      eleId = "url";
      promptMsg = "视频url"; //视频上传默认选中显示播放控件复选框, 并修改格式文本

      var videoCoverDiv; //语法: getContentElement( pageId, elementId )
      //通过输出dialogObj, 点击结果的definition>contents查看tab的id,
      //也就是文档中的pageId, 即第一个参数, 再点击该pageId所在条目即可看到该页面的elements
      //紧接着点击elements, 里面所展示的条目的id就是文档里的elementId, 即第二个参数
      //文档查看技巧: 比如dialogObj.getContentElement("info","url").getElement().getFirst().setText("支持格式: MP4")
      //首先查阅dialog文档, 然后看最开始确定两个参数pageId和elementId, 接着dialog文档显示getContentElement返回结果为
      //uiElement, 则输出结果并结合uiElement文档查看结果, 接着发现需要继续往下获得结果, uiElement文档显示应使用getElement方法,
      //而这个方法返回的是element, 遂再次输出结果并对照element的文档查看, 发现似乎需要使用getFirst获得第一个节点, 接着通过经验
      //得知应该设置节点的text, 遂找到setText, 最后尝试结果, 成功!
      //修改视频类型内容

      dialogObj.getContentElement("info", "url").getElement().getFirst().setText("支持格式: MP4"); //隐藏是否显示控制条的选项

      dialogObj.getElement().findOne("table>tbody>tr>td>div>table>tbody>tr>td>div>table>tbody>tr:nth-child(4)").setStyle("display", "none"); //汉化视频封面

      dialogObj.getContentElement("info", "poster").getElement().getFirst().setText("视频封面"); //增加上传视频封面功能

      videoCoverDiv = dialogObj.getContentElement("info", "poster").getElement();
      videoCoverDiv.findOne("div").setStyle("display", "none"); //防止重复添加上传按钮

      if (!videoCoverDiv.find("div[class='customUploadDialog_cke-videoCover']").count()) {
        videoCoverDiv.appendHtml(videoCoverDOMTemplate); //上传文件相关设置

        (0, _handleUploadFile.handleUploadFile)({
          noFile: noFile,
          dialogObj: dialogObj,
          dialogType: dialogType,
          isVideoCover: true,
          handleUpload: handleUpload,
          uploadBtnId: videoCoverUploadBtnId,
          uploadContainer_ckeDomEle: videoCoverDiv.findOne(".customUploadDialog_cke-videoCover")
        });
      }
    } else if (dialogType == "link") {
      eleId = "url";
      promptMsg = "请输入超链接地址"; //超链接类型只保留一项

      dialogObj.getContentElement("info", "linkType").getElement().findOne("div div>select").setHtml("<option value=\"url\"> \u5730\u5740</option>"); //超链接协议只留两项

      dialogObj.getContentElement("info", "protocol").getElement().findOne("div div>select").setHtml("<option value=\"http://\"> http://&lrm;</option><option value=\"https://\"> https://&lrm;</option>"); //超链接默认新窗口打开(隐藏目标选项卡让用户无法点击)

      dialogObj.getElement().findOne("table>tbody>tr>td>div>div[class='cke_dialog_tabs']>a[title='目标']").setStyle("display", "none");
    } else if (dialogType == "iframe") {
      eleId = "src";
      promptMsg = "请输入框架的 URL";
    } //上传对话框必填校验: 盖住确定按钮的元素的点击事件监听


    var handleFakeOkBtnClick = function handleFakeOkBtnClick() {
      var requireVal = dialogObj.getContentElement("info", eleId).getValue();

      if (!requireVal) {
        handleNotification.warning(promptMsg);
      } else {
        dialogObj.click("ok");
      }
    };

    window.handleFakeOkBtnClick = handleFakeOkBtnClick; //tab选项卡被选中事件

    dialogObj.on('selectPage', function (e) {
      var currentDialogObj = e.sender,
          currentPageId = e.data.page,
          dialogType = currentDialogObj.getName(),
          uploadDiv = currentDialogObj.getElement().findOne("table>tbody>tr>td>div>table>tbody>tr:nth-child(1)>td>div[name='Upload']"),
          uploadDivTable;

      if (currentPageId == "Upload") {
        //清空进度框的值
        var ckeProcess = document.getElementsByClassName('process_cke')[0];

        if (ckeProcess) {
          var ckeProcessTxt = ckeProcess.innerText;

          if (ckeProcessTxt) {
            ckeProcess.innerText = '';
          }
        } //隐藏table之后再追加html到它的父级div中放置关闭对话框报错的问题发生,
        //切勿直接使用setHtml设置html否则关闭时候会报错


        uploadDivTable = uploadDiv.findOne("table");
        uploadDivTable.setStyle("display", "none");

        if (dialogType == "image") {
          //防止重复添加上传按钮
          if (uploadDiv.find("div[class='customUploadDialog_cke']").count() != 0) {
            return;
          }

          uploadDiv.appendHtml(imageDOMTemplate); //上传文件相关设置

          (0, _handleUploadFile.handleUploadFile)({
            noFile: noFile,
            dialogObj: dialogObj,
            dialogType: dialogType,
            handleUpload: handleUpload,
            uploadBtnId: imgUploadBtnId,
            uploadContainer_ckeDomEle: uploadDiv.findOne(".customUploadDialog_cke")
          });
        }

        if (dialogType == "html5video") {
          //防止重复添加上传按钮
          if (uploadDiv.find("div[class='customUploadDialog_cke']").count() != 0) {
            return;
          }

          uploadDiv.appendHtml(videoDOMTemplate); //上传文件相关设置

          (0, _handleUploadFile.handleUploadFile)({
            noFile: noFile,
            dialogObj: dialogObj,
            dialogType: dialogType,
            handleUpload: handleUpload,
            uploadBtnId: videoUploadBtnId,
            uploadContainer_ckeDomEle: uploadDiv.findOne(".customUploadDialog_cke")
          });
        }
      }
    });
  }); //插入元素事件
  // editor.on('insertElement', function(e){
  //     let ckeDomEle = e.data,
  //         videoNode = ckeDomEle.getElementsByTag("video").$;
  //     if(videoNode.length != 0) {
  //         handleVideoFrameShot(videoNode[0]);
  //     }
  // })
  //粘贴事件

  editor.on('paste', function (e) {
    //截图粘贴, 内容为空, 此时禁止粘贴
    //这样就不会触发fileUploadRequest事件去上传图片而无法传最后报错了
    if (!e.data.dataValue) {
      e.cancel();
    } else {
      //阻止事件并禁止视频全屏
      (0, _handleStopPropagationNnofullscreen.handleStopPropagationNnofullscreen)();
    }
  }); //通知事件

  editor.on('notificationShow', function (e) {
    var cancel = e.cancel,
        type = e.data.notification.type,
        msg = e.data.notification.message.replace(/<\/?[^>]+>/g, "");

    switch (type) {
      case "info":
      case "progress":
        handleNotification.info(msg);
        break;

      case "warning":
        handleNotification.error(msg);
        break;

      case "success":
        handleNotification.success(msg);
        break;
    } // Do not show the default notification.


    cancel();
  }); // editor.on('notificationUpdate', function(e){
  // console.log(e);
  // Do not show the notification even if the update was important.
  // e.cancel();
  // });

  editor.on('notificationUpdate', function (e) {
    var options = e.data.options,
        optType = e.data.options.type,
        optMsg = e.data.options.message.replace(/<\/?[^>]+>/g, ""),
        msg = e.data.notification.message.replace(/<\/?[^>]+>/g, "");

    if (options && optMsg != msg) {
      //有更新, 此时应该给外部传入的通知方法传新的消息:e.data.options.message,
      //并传入新的type
      switch (optType) {
        case "info":
        case "progress":
          handleNotification.info(optMsg);
          break;

        case "warning":
          handleNotification.error(optMsg);
          break;

        case "success":
          handleNotification.success(optMsg);
          break;
      }
    }
  }); // editor.on('notificationHide', function(e){
  //     console.log(e);
  // });
  //数据重新加载事件,比如用户按了撤销快捷键时就会触发

  editor.on('dataReady', function (e) {
    //阻止事件并禁止视频全屏
    (0, _handleStopPropagationNnofullscreen.handleStopPropagationNnofullscreen)();
  });
};

exports.handleCkeditorEvents = handleCkeditorEvents;